import { FC, ReactNode } from "react"

import { Skeleton } from "@mui/material"
import { useSkeletonStatusProps } from "components/common/skeleton/skeleton.utils"

interface IProps {
  height: string
  style?: React.CSSProperties
  children?: ReactNode
}

const JobsSkeleton: FC<IProps> = ({ children, height, style }) => {
  const skeletonStatusProps = useSkeletonStatusProps()

  return (
    <Skeleton
      width="100%"
      height={height}
      style={style}
      {...skeletonStatusProps}
    >
      {children}
    </Skeleton>
  )
}

export default JobsSkeleton
